import type { ProductStatusMonitoringRouter } from '@ipen-portal/plugin-product-status-monitoring-backend';
import type { TRPCOptionsProxy } from '@trpc/tanstack-react-query';

import { createApiRef } from '@backstage/frontend-plugin-api';

export const productStatusMonitoringApiRef = createApiRef<
  TRPCOptionsProxy<ProductStatusMonitoringRouter>
>().with({
  id: 'plugin.ipen.product-status-monitoring.api',
});
